import { useEffect } from "react";
import { useWidgetStore } from "../../store/widget-store";
import { getWidgetKey } from "../../lib/widget-key";
import { ProductCard } from "./ProductCard";

export function ShopTab() {
  const products = useWidgetStore((state) => state.products);
  const status = useWidgetStore((state) => state.productsStatus);
  const error = useWidgetStore((state) => state.productsError);
  const loadProducts = useWidgetStore((state) => state.loadProducts);

  useEffect(() => {
    const publicKey = getWidgetKey();
    if (!publicKey) return;
    void loadProducts(publicKey);
  }, [loadProducts]);

  if (status === "loading") {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-gray-400">
        Loading products…
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="flex flex-1 items-center justify-center px-4 text-center text-sm text-red-500">
        {error ?? "Couldn't load products."}
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center px-4 text-center text-sm text-gray-400">
        No products available yet.
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col gap-2 overflow-y-auto p-3">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
}
